import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { NumberBadge } from '@/components/ui/Badge/NumberBadge';
import { FlatTabs, FlatTab } from '@/components/ui/Tab/FlatTab';
import { clientRfpOneOfferPath, clientRfpOneQuestionPath, clientRfpOneMessagePath, clientRfpOneFileAllPath, } from '@/utils/router/links';
const tabValueOffer = 'offer';
const tabValueQuestion = 'question';
const tabValueNegotiate = 'negotiate';
const tabValueFile = 'file';
/**
 * クライアント：案件詳細のタブ
 * @param props
 * @constructor
 */
export const RfpClientOneTab = (props) => {
    const { activeValue, className = '', id = '', isShowFileTab = true, isSkeleton = false, unansweredQuestionCount = 0, unapprovedCount = 0, unreadFileCount = 0, unreadMessageCount = 0, } = props;
    const tabs = useMemo(() => {
        const values = [
            {
                count: unapprovedCount,
                labelPc: _jsx(_Fragment, { children: "\u52DF\u96C6\u72B6\u6CC1\u3092\u898B\u308B" }),
                labelSp: (_jsxs(_Fragment, { children: ["\u52DF\u96C6", _jsx("br", {}), "\u72B6\u6CC1"] })),
                url: clientRfpOneOfferPath(id),
                value: tabValueOffer,
            },
            {
                count: unansweredQuestionCount,
                labelPc: _jsx(_Fragment, { children: "\u8CEA\u554F\u306B\u56DE\u7B54\u3059\u308B" }),
                labelSp: (_jsxs(_Fragment, { children: ["\u8CEA\u554F", _jsx("br", {}), "\u56DE\u7B54"] })),
                url: clientRfpOneQuestionPath(id),
                value: tabValueQuestion,
            },
            {
                count: unreadMessageCount,
                labelPc: _jsx(_Fragment, { children: "\u6761\u4EF6\u306E\u76F8\u8AC7\u3092\u3059\u308B" }),
                labelSp: (_jsxs(_Fragment, { children: ["\u6761\u4EF6", _jsx("br", {}), "\u76F8\u8AC7"] })),
                url: clientRfpOneMessagePath(id),
                value: tabValueNegotiate,
            },
        ];
        if (isShowFileTab) {
            values.push({
                count: unreadFileCount,
                labelPc: _jsx(_Fragment, { children: "\u8CC7\u6599\u3092\u5171\u6709\u3059\u308B" }),
                labelSp: (_jsxs(_Fragment, { children: ["\u8CC7\u6599", _jsx("br", {}), "\u5171\u6709"] })),
                url: clientRfpOneFileAllPath(id),
                value: tabValueFile,
            });
        }
        return values;
    }, [
        id,
        isShowFileTab,
        unreadFileCount,
        unreadMessageCount,
        unansweredQuestionCount,
        unapprovedCount,
    ]);
    return (_jsx(FlatTabs, Object.assign({ className: clsx('px-16 md:px-0 lg:px-16 xl:px-0', className) }, { children: tabs.map((tab) => (_jsx(FlatTab, Object.assign({ activeValue: activeValue, innerPadding: '', to: tab.url, value: tab.value }, { children: !isSkeleton && (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ className: clsx('hidden lg:hidden xl:inline') }, { children: tab.labelPc })), _jsx("span", Object.assign({ className: clsx('inline lg:inline xl:hidden') }, { children: tab.labelSp })), tab.count > 0 && _jsx(NumberBadge, { number: tab.count })] })) }), tab.value))) })));
};
export const rfpClientOneTabValueOffer = tabValueOffer;
export const rfpClientOneTabValueQuestion = tabValueQuestion;
export const rfpClientOneTabValueNegotiate = tabValueNegotiate;
export const rfpClientOneTabValueFile = tabValueFile;
